import ApiUtils from '@/utils/api/ApiUtils'
import C0101Const from './C0101Const'
import C1001Const from '../C1001ProjectCrowdFund/C1001Const'
import C2001Const from '../C2001ProjectInvestment/C2001Const'
import C3001Const from '../C3001ProjectPartnerRequirement/C3001Const'
import C4001Const from '../C4001ProjectAdvise/C4001Const'

// 0 = hide, 1 = show
const defaultStatus = {
  showSubmitForReviewButton: 0,
  showSaveButton: 0,
  showReviewNotification: 1,
  showPreviewButton: 1,
  showPublishButton: 0
}

const StoreConst = C0101Const.storeConst
const store = {
  state: {
    forms: [],
    orderBy: { order_created_at: 'DESC' },
    statusMapping: {
      DRAFT: {
        ...defaultStatus,
        showSubmitForReviewButton: 1,
        showSaveButton: 1,
        showReviewNotification: 0
      },
      PENDING: { ...defaultStatus },
      APPROVED: {
        ...defaultStatus,
        showPublishButton: 1,
        showSaveButton: 1
      },
      AMENDMENT: {
        ...defaultStatus,
        showSubmitForReviewButton: 1,
        showSaveButton: 1
      },
      REJECTED: { ...defaultStatus },
      SCHEDULED: { ...defaultStatus },
      PUBLISHED: { ...defaultStatus },
      PREPARE: { ...defaultStatus },
      FUND_FALIED: { ...defaultStatus },
      DEVELOPMENT: { ...defaultStatus },
      DELIVERED: { ...defaultStatus },
      ARCHIVED: { ...defaultStatus },
      DELETED: { ...defaultStatus },
      REMOVED: { ...defaultStatus }
    }
  },
  getters: {
    getForms: state => state.forms,
    getStatusArray: state => Object.keys(state.statusMapping)
  },
  mutations: {
    SET_ROW_MERGE (state, payload) {
      state.row = { ...state.row, ...payload }
    },
    SET_FORMS (state, payload) {
      state.forms.push(payload)
    }
  },
  actions: {
    async doEdit ({ state, dispatch }) {
      return await ApiUtils.postData({
        data: [{ api: StoreConst.ACTION.doEdit.api, input: state.row }]
      }).then(data => {
        dispatch(
          C1001Const.storeConst.ACTION.doEdit.store,
          { c0101_id: data[0].output.id, project_intention: state.row.project_intention },
          { root: true }
        )
        dispatch(
          C2001Const.storeConst.ACTION.doEdit.store,
          { c0101_id: data[0].output.id, project_intention: state.row.project_intention },
          { root: true }
        )
        dispatch(
          C3001Const.storeConst.ACTION.doEdit.store,
          { c0101_id: data[0].output.id, project_intention: state.row.project_intention },
          { root: true }
        )
        dispatch(
          C4001Const.storeConst.ACTION.doEdit.store,
          { c0101_id: data[0].output.id, project_intention: state.row.project_intention },
          { root: true }
        )
      })
    },
    async doSubmit ({ state, dispatch }) {
      dispatch('doEdit')
      return await ApiUtils.postData({
        data: [{ api: StoreConst.ACTION.doSubmit.api, input: { id: state.row.id } }]
      })
    },
    async reviewComplete ({ state, dispatch }, payload) {
      return await ApiUtils.postData({
        data: [{ api: 'C0101ProjectService.reviewComplete', input: payload }]
      })
    },
    async doPublish ({ state, dispatch }) {
      return await ApiUtils.postData({
        data: [{ api: 'C0101ProjectService.doPublish', input: { id: state.row.id } }]
      })
    }
  }
}

export default C0101Const.getStore(store)
